// https://sistemas.ucasal.edu.ar/sagbackend/api/v1/registro-inicial/inscripcion-habilitada?tdocu=${document_type}&ndocu=${document_number}&lugar=${id_lugar}&sector=${id_sector}&carrera=${id_carrera}&modo=${id_modo}&anio=${year}

import { SERVICES_URL } from "../../config/config";
import generateTokenService from "../../services/auth/generate-token";

const getEnrollmentEnabled = async ({ token, callbacks, params }) => {
  try {
    let currentToken = token;

    if (!currentToken) {
      currentToken = await new Promise((resolve, reject) => {
        generateTokenService({
          callbacks: (response) => {
            if (response.success) {
              resolve(response.data.token);
            } else {
              reject(response);
            }
          },
        });
      });
    }

    const url =
      SERVICES_URL.CHECKBOXES.ENROLLMENT +
      `?tdocu=${params.tdocu}&ndocu=${params.ndocu}` +
      `&carrera=${params.carrera}&modo=${params.modo}` +
      `&anio=${params.anio}&lugar=${params.lugar}&sector=${params.sector}`;

    //const response = await connection({ method: 'GET', url: `${SERVICES_URL.CHECKBOXES.ENROLLMENT}`, token, params });
    // const res= await fetch('http://localhost:8081/v1/registro-inicial/inscripcion-habilitada-carrera'+'?tdocu='+params.tdocu+'&ndocu='+params.ndocu+'&carrera='+params.carrera+'&modo='+params.modo+'&anio='+params.anio+'&lugar='+params.lugar+'&sector='+params.sector,{    
    const res = await fetch(url, {
      method: "GET",
      headers: {
        auth: currentToken,
      },
    });

    const jsonRes = await res.json();

    if (typeof callbacks === "function") {
      if (res.status === 200) {
        callbacks({
          success: true,
          data: jsonRes,
        });
      } else {
        callbacks({
          success: false,
          error: {
            errors: [
              jsonRes?.message ||
              "Error al obtener la información, comuníquese mesa de ayuda",
            ],
          },
        });
      }
    }
  } catch (error) {
    console.error("Error en getEnrollmentEnabled:", error);

    if (typeof callbacks === "function") {
      callbacks({
        success: false,
        error: {
          errors: [
            "Ocurrió un error con el servidor. Intenta nuevamente más tarde",
          ],
        },
      });
    }
  }
};

export default getEnrollmentEnabled;